import { Modal } from 'antd';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { SETTING_KEYS } from 'utils/common/const';

const RulePage = ({ isModalRule, setIsModalRule }) => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    if (isModalRule) {
      fetchAllSetting();
    }
  }, [isModalRule]);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      console.log('res settings', res);
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const handleClose = () => {
    setIsModalRule(false);
  };

  return (
    <Modal
      open={isModalRule}
      onCancel={handleClose}
      footer={null}
      width={1000}
      centered
      className="rule-modal"
    >
      <div className="w-full h-auto max-h-[70vh] overflow-y-auto">
        <div
          className="mx-auto bg-white/95 border-solid border-[#26A9E0] border-[6px] rounded-3xl shadow shadow-primary p-2 md:pb-8 md:pt-4 md:px-10 w-full"
        >
          <div
            dangerouslySetInnerHTML={{
              __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RulePage;
